import React, { useState } from 'react'
import { Container, Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { CircleSpinner, getErrorWithFullMessage } from 'shared/index'
import { appRoutes } from 'selfServicePortal/constants/routes'
import authenticationService from 'auth/services/authenticationService'

function NorwegianBankIdCallbackPage() {
	const [error, setError] = useState<Error>()
	const [isWaiting, setIsWaiting] = useState(false)
	const { t } = useTranslation()
	React.useEffect(
		() => {
			signin()
		},
		// eslint-disable-next-line
		[],
	)
	async function signin() {
		const search = window.location.search
		const params = new URLSearchParams(search)
		const redirectUrl = sessionStorage.getItem('redirectUrl')
		setIsWaiting(true)
		try {
			if (window.location.search.indexOf('error_description') !== -1) {
				window.location.href = 'https://tfbank.no/minside'

				//const errorMsg = params.get('error_description')
				//setError(new Error(errorMsg ? errorMsg : ''))
			} else if (window.location.search.indexOf('code') > -1) {
				let authResult
				if (redirectUrl?.includes('application')) {
					authResult =
						await authenticationService.norwegianBankIdApplicationResultGet(
							search,
							t,
						)
				} else {
					authResult =
						await authenticationService.norwegianBankIdResultGet(
							search,
							t,
						)
				}
				authenticationService.redirectTo(
					window.location.origin + appRoutes.callbackPage,
					authResult.secret,
				)
			}
		} catch (error: any) {
			setError(getErrorWithFullMessage(error))
		}
	}
	return (
		<Container className="d-flex justify-content-center align-items-center vh-100">
			{error ? (
				<Alert
					variant="danger"
					dismissible
					onClose={() => (window.location.href = appRoutes.login)}>
					{error.message}
				</Alert>
			) : isWaiting ? (
				<CircleSpinner />
			) : (
				<></>
			)}
		</Container>
	)
}
export default NorwegianBankIdCallbackPage
